/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "../../components/LinkIcon";
import "./styles.less";
export const VerifyPageCard = ({ title = "", contentList = [], docLink }) => {
  const { t } = useTranslation();
  return (
    <div className={`verifyPage-card`}>
      <div className="title-top">
        <div className="title-text">{title}</div>
      </div>
      <div className="sdk-list-warp">
        {contentList.map((item, index) => (
          <>
            <div className="item-list-warp">
              <i class="icon authing-icon authing-checkbox-circle-fill checked"></i>
              <div className="item-list">{item}</div>
            </div>
          </>
        ))}
      </div>

      <div>
        <Link href={docLink} target="_blank">
          {t("common.button.linkDoc")}
        </Link>
      </div>
    </div>
  );
};
export const VerifyPageSDK = () => {
  const { t } = useTranslation();
  const VerifyPageCardOne = {
    title: t("learn.verifyPage.step-three.item1.title"),
    contentList: [
      t("learn.verifyPage.step-three.item1.list1"),
      t("learn.verifyPage.step-three.item1.list2"),
    ],
    docLink:
      "https://docs.authing.cn/v2/guides/wechat-ecosystem/wechat-miniprogram-qrcode/?social-login=sdk",
  };
  const VerifyPageCardTwo = {
    title: t("learn.verifyPage.step-three.item2.title"),
    contentList: [
      t("learn.verifyPage.step-three.item2.list1"),
      t("learn.verifyPage.step-three.item2.list2"),
      t("learn.verifyPage.step-three.item2.list3"),
    ],
    docLink:
      "https://docs.authing.cn/v2/guides/wechat-ecosystem/wechat-miniprogram-qrcode/?social-login=embeded-component",
  };
  const VerifyPageCardThree = {
    title: t("learn.verifyPage.step-three.item3.title"),
    contentList: [
      t("learn.verifyPage.step-three.item3.list1"),
      t("learn.verifyPage.step-three.item3.list2"),
    ],
    docLink:
      "https://docs.authing.cn/v2/guides/wechat-ecosystem/wechat-miniprogram-qrcode/?social-login=hosted-page",
  };

  return (
    <div className="verify-content-sdk">
      <div className="verify-content-sdk-title">
        {t("learn.verifyPage.step-three.title")}
      </div>
      <div className="verify-content-sdk-subtitle">
        {t("learn.verifyPage.step-three.descript")}
      </div>
      <div className="verify-content-card-warp">
        <VerifyPageCard {...VerifyPageCardOne} />
        <VerifyPageCard {...VerifyPageCardTwo} />
        <VerifyPageCard {...VerifyPageCardThree} />
      </div>
    </div>
  );
};
